import { render } from "./ExpenseCategory.vue?vue&type=template&id=327c9438"
import script from "./ExpenseCategory.vue?vue&type=script&lang=js"
export * from "./ExpenseCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__